// extracted by mini-css-extract-plugin
export default {"formsContent":"styles_formsContent__NtTp1","loader":"styles_loader__0Nd9R","formPageWrapper":"styles_formPageWrapper__o6ji3"};